export default __webpack_public_path__ + "ec27bcdc5a2f364c4ba09190a7a69c75.png";